import type { CheckoutWebComponents, Component } from '@checkout.com/checkout-web-components'
import type * as ApplePayJS from '@dni-types/payment/applepay-types'
import { type ApplePayPaymentDetails, type FlowPaymentSetting } from '../types'
import { BaseCheckoutPayFlowModule } from './BaseCheckoutPayFlowModule'
import { PAYMENT_DIALOG_TYPE, type PaymentDialogType } from './payment-dialog-type'

export class CheckoutPayApplePayModule extends BaseCheckoutPayFlowModule {
  protected createComponent(
    checkout: CheckoutWebComponents,
    callbacks: Parameters<BaseCheckoutPayFlowModule['createComponent']>[1],
  ): Component {
    return checkout.create('applepay', { ...callbacks })
  }

  public override mountsInDialog(): boolean {
    return true
  }

  public override getPaymentDialogType(): PaymentDialogType {
    return PAYMENT_DIALOG_TYPE.APPLE_PAY
  }

  public override configurePayment(details: FlowPaymentSetting | ApplePayPaymentDetails): void {
    if (
      'currency' in details
      || 'countryCode' in details
      || 'orderTotalAmount' in details
      || 'onCancel' in details
      || 'onValidateMerchant' in details
    ) {
      console.warn(
        '[CheckoutPayApplePayModule]',
        'Apple-Pay-specific fields (currency / countryCode / orderTotalAmount / onCancel / onValidateMerchant) are ignored in Flow mode.',
        'Migrate to module.setComponentOptions({ applepay: { ... } }).',
      )
    }
    super.configurePayment(details)
  }

  /** @deprecated Replaced by Flow lifecycle (setPaymentSession → mount → submit). */
  public createApplePayToken(): Promise<ApplePayJS.ApplePayPaymentToken> {
    throw new Error('[CheckoutPayApplePayModule] createApplePayToken() removed in Flow migration.')
  }
}
